// prefixMessage - Using prefixMessage is an easy way to setup a clue to locate the error
//   The prefixMessage can be the name of a function where the error is from
//   Since the Js trace is not friendly for debugging, try to use prefixMessage as much as possible
// exception - send errbit message when it is true, log to Rails logger only when it is false
function logError(errDetails, prefixMessage = '', exception = true, { trace } = {}) {
  const { message: errMessage = '' } = errDetails;
  const message = `${prefixMessage} ${errMessage}`;

  let details = { ...errDetails, message, trace: trace || Error().stack };

  if (message) details = { ...errDetails, message };
  else details = { ...errDetails };

  console.error(details);
}

export default logError;
